export var domainApiRelativePath = "/helpcenter/domain";
export var createDomainApi = function (baseUrl, http) {
    var apiUrl = "".concat(baseUrl).concat(domainApiRelativePath);
    return {
        getDomainSettings: function (brandId) {
            return http.get("".concat(apiUrl).concat(brandId ? "?brandId=".concat(brandId) : ''));
        },
        linkDomain: function (dto) { return http.put("".concat(apiUrl, "/connect"), dto); },
        unlinkDomain: function (brandId) { return http.put("".concat(apiUrl, "/disconnect"), { brandId: brandId }); },
        checkDomainStatus: function (domain) { return http.get("".concat(apiUrl, "/check?domain=").concat(domain)); }
    };
};
//# sourceMappingURL=index.js.map